import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  const done = useRef(false);
  useEffect(() => {
    if (done.current) { return; }
    done.current = true;
    api.post(`/public/unsubscribe/${token}`).then((r) => setState({ ok: true, name: r.data.client_name })).catch((e) => setState({ error: errMsg(e) }));
  }, [token]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="card-box w-full max-w-md p-8 text-center" data-testid="unsubscribe-card">
        <p className="mb-4 font-display text-xl font-bold text-slate-900">RinoTECH</p>
        {state.loading && <Loader2 className="mx-auto h-8 w-8 animate-spin text-slate-400" />}
        {state.ok && <>
          <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" />
          <h1 className="mt-3 text-lg font-semibold text-slate-900" data-testid="unsubscribe-success">Baja confirmada</h1>
          <p className="mt-2 text-sm text-slate-600">{state.name}: ya no recibirá correos de marketing. Seguirá recibiendo los avisos de su cuenta (facturas, renovaciones y proyectos), que puede ajustar en su portal.</p>
        </>}
        {state.error && <>
          <XCircle className="mx-auto h-10 w-10 text-rose-600" />
          <p className="mt-3 text-sm text-rose-700" data-testid="unsubscribe-error">{state.error}</p>
        </>}
        <Link to="/login" className="mt-6 inline-block text-sm text-blue-700 hover:underline" data-testid="unsubscribe-login-link">Ir a mi portal</Link>
      </div>
    </div>
  );
}
